const PresentationTableElements = document.querySelectorAll(
  '.PresentationSlideTable',
)

function scaleContentToFit() {
  Array.prototype.forEach.call(
    PresentationTableElements,
    function (tableElement) {
      const wrapper = tableElement.querySelector('.table-container')
      const viewport = tableElement.querySelector(
        '.PresentationSlideTable-text',
      )

      // Reset scale to 1
      wrapper.style.transform = 'scale(1) translate(0, 0)'

      const contentWidth = wrapper.offsetWidth
      const contentHeight = wrapper.offsetHeight

      const viewportWidth = viewport.clientWidth
      const viewportHeight = viewport.clientHeight

      const scaleX = viewportWidth / contentWidth
      const scaleY = viewportHeight / contentHeight
      const scale = Math.min(scaleX, scaleY, 1) // nicht größer als 1

      const offsetX = (viewportWidth - contentWidth * scale) / 2
      const offsetY = (viewportHeight - contentHeight * scale) / 2

      wrapper.style.transform = `scale(${scale}) translate(${offsetX / scale}px, ${offsetY / scale}px)`
    },
  )
}

window.addEventListener('load', scaleContentToFit)
window.addEventListener('resize', scaleContentToFit)
